export class Tenant {
  name: string
  cluster: string
  defaultCluster: string
  prefix: string
  blipChatUrl: string
}
